<template>
  <div class="section-header" :class="color">
    <span class="section-title">
      <img class="icon" src="../../../assets/icons/lock-outline.svg"/>
      {{ titleText }}
    </span>
    <div class="section-seperator"></div>
  </div>
</template>

<script>

export default {
  name: 'CredentialsSettingsSectionHeader',
  props: [
    'titleText',
    'color',
  ],
};

</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .section-header {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-end;

    .section-title {
      font-family: SimplerProBold;
      color: $riseup_white;
      font-size: 14px;
      line-height: 14px;
      padding: 3px;
      padding-top: 4px;
      padding-left: 6px;
      white-space: nowrap;

      .icon {
        vertical-align: middle;
        padding-bottom: 2px;
      }
    }

    .section-seperator {
      height: 2px;
      width: 100%;
    }

    &.coral {
      .section-title, .section-seperator {
        background: $riseup_coral;
      }
    }

    &.green {
      .section-title, .section-seperator {
        background: $riseup_green;
      }
    }

    &.black {
      .section-title, .section-seperator {
        background: $riseup_black;
      }
    }

    &.mustard {
      .section-title, .section-seperator {
        background: $riseup_mustard;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/credentials/credentials-list/CredentialsSettingsSectionHeader.vue